<template>
  <div v-if="shouldRenderConfig && getShowAddToCart" :class="getClassName">
    <button
      type="button"
      class="btn btn-primary"
      :disabled="isDisabled"
      :class="getDisableClass"
      @click="onClickAddToCart"
    >
      {{ $t("Add to Cart") }}
    </button>
  </div>
</template>
<script>
import { useQuantityFieldStore } from "@/stores/modules/quantityField";
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { mapState, mapActions } from "pinia";
import { callbackService } from "../../helpers/callbackService";
import { usePersonalizeStore } from "@/stores/modules/personalize";
import { useQuoteStore } from "@/stores/modules/quote";

import { i18n } from "../../i18n.js";
import * as R from "ramda";

export default {
  computed: {
    ...mapState(useChangeOptionsStore, [
      "getAddToCartCallbacks",
      "getIsChangeOptionsLoading",
      "getChangeOptionsPostData",
      "getQuantity",
      "getChangeOptionsData"
    ]),
    ...mapState(useWebproductStore, [
      "getHasAutomaticConnect",
      "getFilesConnectLoading",
      "getNumberOfActiveUploads",
      "getIsValidForm",
      "getCallChangeOptionPerType",
      "getShowAddToCart",
      "getIsLfp"
    ]),
    ...mapState(useQuantityFieldStore, ["getQuantityField"]),
    ...mapState(useQuoteStore, ["getIsQuoteMode"]),
    getDisableClass: function () {
      return this.getIsChangeOptionsLoading ||
        this.getFilesConnectLoading ||
        this.getNumberOfActiveUploads > 0
        ? "disable"
        : "";
    }
  },
  methods: {
    ...mapActions(useImageEditorStore, ["completePersonalization"]),
    ...mapActions(useQuantityFieldStore, ["setQuantityField"]),
    ...mapActions(useChangeOptionsStore, ["setIsChangeOptionsLoading"]),
    ...mapActions(usePersonalizeStore, ["setPersonalizeLoading"]),
    onClickAddToCart: function (event) {
      var valid = this.validate();
      if (!valid) {
        return;
      }
      this.setPersonalizeLoading(true);
      if (this.getAddToCartCallbacks) {
        R.forEach(callback => {
          if (typeof callback === "function") callback(event);
        }, this.getAddToCartCallbacks);
      }

      var qty = this.getChangeOptionsData.qty;
      if (qty == undefined) {
        // happens for personlization when opened in iframe
        qty = this.getQuantity;
      }
      if (!qty) {
        qty = 1;
        this.setQuantityField(qty);
        return;
      }

      var onCartData = this.getChangeOptionsPostData(false);
      if (!this.getCallChangeOptionPerType) {
        onCartData.qty = qty;
      }
      if (this.getIsQuoteMode) {
        onCartData.quote_mode = 1;
      }
      if (this.getIsLfp) {
        var payload = {
          onCartDataEncoded: btoa(JSON.stringify(onCartData)),
          onCartData: onCartData
        };
        this.completePersonalization(payload);
      } else {
        this.setIsChangeOptionsLoading(true);
        callbackService.sendCallback(
          callbackService.callbacks.onCartSubmitCallback,
          onCartData
        );
      }
    },

    validate: function () {
      return this.getIsValidForm(this);
    }
  },
  props: ["isDisabled"]
};
</script>
